import React, { useEffect, createElement } from 'react';
import { ArrowRightIcon, PaletteIcon, SearchIcon, MousePointerClickIcon, ExternalLinkIcon } from 'lucide-react';
import { FinalCtaSection } from '../components/FinalCtaSection';
const voorbeelden = [{
  title: 'Installatiebedrijf De Vries',
  branche: 'Bouw & installatie',
  image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop',
  tags: ['WordPress', 'SEO', 'Responsive']
}, {
  title: 'Restaurant Het Kaasplein',
  branche: 'Horeca',
  image: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800&h=500&fit=crop',
  tags: ['WordPress', 'Reserveringen', 'Fotografie']
}, {
  title: 'Advocatenkantoor Bakker & Zoon',
  branche: 'Zakelijke dienstverlening',
  image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=500&fit=crop',
  tags: ['Maatwerk', 'SEO', 'Conversie']
}, {
  title: 'Fysiotherapie Alkmaar Centrum',
  branche: 'Zorg',
  image: 'https://images.unsplash.com/photo-1559028012-481c04fa702d?w=800&h=500&fit=crop',
  tags: ['WordPress', 'Online afspraken', 'SEO']
}, {
  title: 'Bloemenwinkel Flora',
  branche: 'Retail',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=500&fit=crop',
  tags: ['Webshop', 'WordPress', 'Responsive']
}, {
  title: 'Accountantskantoor Noordzij',
  branche: 'Zakelijke dienstverlening',
  image: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=800&h=500&fit=crop',
  tags: ['Maatwerk', 'Portaal', 'SEO']
}];
export function WebsiteVoorbeeldenPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Website voorbeelden | Inspiratie voor je website | Noord';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Inspirerende website voorbeelden per sector. Bekijk professionele websites voor MKB, ZZP, horeca, zorg en meer. Ontdek wat een goede bedrijfswebsite kenmerkt.';
    // Open Graph meta tags
    const ogTags: Record<string, string> = {
      'og:title': 'Website voorbeelden | Inspiratie voor je website | Noord',
      'og:description': 'Inspirerende website voorbeelden per sector. Bekijk professionele websites voor MKB, ZZP, horeca, zorg en meer.',
      'og:type': 'article',
      'og:url': 'https://noorddigital.nl/website-voorbeelden',
      'og:site_name': 'Noord Digital',
      'og:locale': 'nl_NL'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    const handleScroll = () => {
      const hero = document.querySelector('.hero');
      if (hero) {
        const rect = hero.getBoundingClientRect();
        if (rect.top <= 0 && rect.bottom >= 0) {
          hero.classList.add('active');
        } else {
          hero.classList.remove('active');
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <main className="pt-16 lg:pt-[72px]" data-id="element-2849" data-mp="1dbcuow4x2997">
      {/* Hero */}
      <section className="relative py-20 lg:py-32 bg-navy-900 overflow-hidden" data-id="element-2850" data-mp="2ar8lhcnvjzun">
        <div className="absolute inset-0 pointer-events-none" data-id="element-2851" data-mp="2atd0apnbaj9p">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl bg-accent" data-id="element-2852" data-mp="25z8q7xir1v4e" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl bg-accent-light" data-id="element-2853" data-mp="1qkv7ky6e8dl4" />
          <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-2854" data-mp="1gkm9tfwr6k3m" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2855" data-mp="29bmdtqv33nva">
          {/* Breadcrumb */}
          <nav className="flex items-center justify-center gap-2 text-sm mb-8 animate-fade-in-up" data-id="element-2856" data-mp="1zjqekch9hrph">
            <a href="#/" className="text-navy-400 hover:text-white transition-colors" data-id="element-2857" data-mp="24ia2giff1dkh">
              Home
            </a>
            <span className="text-navy-500" data-id="element-2858" data-mp="2s6tbj06ahudm">/</span>
            <a href="#/kennisbank" className="text-navy-400 hover:text-white transition-colors" data-id="element-2859" data-mp="2wzdybhqs377n">
              Kennisbank
            </a>
            <span className="text-navy-500" data-id="element-2860" data-mp="gkskjyiz562s">/</span>
            <span className="text-accent-light font-medium" data-id="element-2861" data-mp="gk9b767e3q0d">
              Website voorbeelden
            </span>
          </nav>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 animate-fade-in-up" data-id="element-2862" data-mp="vbhvr0wfql6n">
            Inspirerende website voorbeelden
          </h1>
          <p className="text-lg lg:text-xl text-navy-200 max-w-2xl mx-auto mb-10 animate-fade-in-up-delay-1" data-id="element-2863" data-mp="2ljcxn8u3kaf">
            Bekijk voorbeelden van moderne bedrijfswebsites die wij hebben
            gebouwd. Laat je inspireren voor jouw eigen website.
          </p>
          <div className="animate-fade-in-up-delay-2" data-id="element-2864" data-mp="7jkvm72clhld">
            <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-bold px-8 py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-lg" data-id="element-2865" data-mp="7m74ca0z6356">
              Eigen website laten maken
              <ArrowRightIcon className="w-5 h-5" data-id="element-2866" data-mp="kmx56s1kimbp" />
            </a>
          </div>
        </div>
      </section>

      {/* Voorbeelden grid */}
      <section className="py-24 bg-surface-muted" data-id="element-2867" data-mp="pnb5fnwxgrz6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2868" data-mp="tomxe039xpaj">
          <div className="text-center mb-16" data-id="element-2869" data-mp="tlsewe3tmejr">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2870" data-mp="3t41iunuua7aw">
              Website voorbeelden per branche
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-2871" data-mp="1uuo5fl0l40x">
              Elke website is uniek ontworpen voor de specifieke doelgroep en
              branche van de klant.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2872" data-mp="ar3joj5vfihs">
            {voorbeelden.map(item => <div key={item.title} className="group bg-white rounded-2xl overflow-hidden shadow-card hover:shadow-medium transition-all duration-300" data-id="element-2873" data-mp="3edu5unnlpghl">
                <div className="aspect-[16/10] overflow-hidden relative" data-id="element-2874" data-mp="31v8dwlv9awvr">
                  <img src={item.image} alt={`Website voorbeeld: ${item.title}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-2875" data-mp="2xu4w3ttneqrw" />
                  <div className="absolute inset-0 bg-navy-900/0 group-hover:bg-navy-900/40 transition-colors duration-300 flex items-center justify-center" data-id="element-2876" data-mp="2nwqpelxj1gcs">
                    <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white text-navy-900 font-semibold px-4 py-2 rounded-button text-sm flex items-center gap-2" data-id="element-2877" data-mp="2e5w2dfcgicqa">
                      Bekijk voorbeeld
                      <ExternalLinkIcon className="w-4 h-4" data-id="element-2878" data-mp="25465htzt2ll4" />
                    </span>
                  </div>
                </div>
                <div className="p-6" data-id="element-2879" data-mp="208qqgyq2ajn4">
                  <p className="text-xs font-semibold text-accent uppercase tracking-wider mb-2" data-id="element-2880" data-mp="3o2uadeo5rnwu">
                    {item.branche}
                  </p>
                  <h3 className="text-lg font-bold text-navy-900 mb-3" data-id="element-2881" data-mp="3t02s5e5e9pxk">
                    {item.title}
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-2882" data-mp="3k18qvah4cbdo">
                    {item.tags.map(tag => <span key={tag} className="text-xs bg-navy-50 text-navy-600 px-2.5 py-1 rounded-full font-medium" data-id="element-2883" data-mp="35c2udu9o0z9h">
                        {tag}
                      </span>)}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Wat maakt een goede website */}
      <section className="py-24 bg-white" data-id="element-2884" data-mp="2me8o3nzx91us">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2885" data-mp="2rctnjl7cnhi6">
          <div className="text-center mb-16" data-id="element-2886" data-mp="2rc1ryadr5jrw">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2887" data-mp="27qi28lj7efrd">
              Wat maakt een goede website?
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-2888" data-mp="22thvs9ifzazq">
              Een succesvolle website combineert drie essentiële elementen.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2889" data-mp="2cpux9tk8at51">
            <div className="border border-navy-100 rounded-card p-8 text-center" data-id="element-2890" data-mp="2qpw03ek20an5">
              <div className="w-14 h-14 rounded-xl bg-accent-light flex items-center justify-center mx-auto mb-6" data-id="element-2891" data-mp="2qnj96bwbipxy">
                <PaletteIcon className="w-7 h-7 text-accent" data-id="element-2892" data-mp="30fp9c8wq4do8" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2893" data-mp="30hjm2zxuczh8">Design</h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2894" data-mp="2vh47y65qjny7">
                Een professioneel en modern ontwerp dat vertrouwen wekt en jouw
                merkidentiteit versterkt. Eerste indrukken tellen.
              </p>
            </div>
            <div className="border border-navy-100 rounded-card p-8 text-center" data-id="element-2895" data-mp="1weom306as4w9">
              <div className="w-14 h-14 rounded-xl bg-accent-light flex items-center justify-center mx-auto mb-6" data-id="element-2896" data-mp="1wgrnshgtbmgt">
                <SearchIcon className="w-7 h-7 text-accent" data-id="element-2897" data-mp="1movkmrzvd65q" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2898" data-mp="1mmsjpcx6hsm8">SEO</h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2899" data-mp="1hrvgimmkydh9">
                Technische optimalisatie en slimme content zodat jouw website
                goed vindbaar is in Google voor relevante zoekwoorden.
              </p>
            </div>
            <div className="border border-navy-100 rounded-card p-8 text-center" data-id="element-2900" data-mp="25fd2u2n2sjcu">
              <div className="w-14 h-14 rounded-xl bg-accent-light flex items-center justify-center mx-auto mb-6" data-id="element-2901" data-mp="21e1jufypiwdm">
                <MousePointerClickIcon className="w-7 h-7 text-accent" data-id="element-2902" data-mp="u07sqdkm7ij7" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2903" data-mp="pz4gs25ou6n9">
                Conversie
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2904" data-mp="31mrfep48pfqg">
                Strategische call-to-actions en gebruiksvriendelijke navigatie
                die bezoekers omzetten in klanten en aanvragen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Gerelateerde pagina's */}
      <section className="py-16 bg-surface-muted border-b border-navy-100" data-id="element-2905" data-mp="3feo40j6p97i3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2906" data-mp="3kd8wtxjmgowi">
          <h3 className="text-lg font-semibold text-navy-900 mb-6" data-id="element-2907" data-mp="3pbsj5z24o2pe">
            Gerelateerde pagina's:
          </h3>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-2908" data-mp="3tcvz0lk6dyqm">
            <a href="#/website-laten-maken" className="inline-flex items-center gap-1.5 text-accent hover:text-accent-hover font-medium underline underline-offset-4 transition-colors" data-id="element-2909" data-mp="3tbb6f1hf8pve">
              Website laten maken
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-2910" data-mp="23z8y2pwij5au" />
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-2911" data-mp="378v6crgpg3gj">•</span>
            <a href="#/wordpress-websites" className="inline-flex items-center gap-1.5 text-accent hover:text-accent-hover font-medium underline underline-offset-4 transition-colors" data-id="element-2912" data-mp="37b7y1wc9ls6s">
              WordPress websites
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-2913" data-mp="3ba711befrevl" />
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <FinalCtaSection data-id="element-2914" data-mp="3q5wdahttkdn4" />
    </main>;
}